//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[[0,"ClassificationItem",0,"AME.SelectClassificationBuilder",0],[0,"EoName",1,0],[0,"IndexDigitsInFunction",1,0],[0,"IndexDigitsInLocation",1,0],[0,"IndexDigitsInProduct",1,0],[0,"IndexIncrementInFunction",1,0],[0,"IndexIncrementInLocation",1,0],[0,"IndexIncrementInProduct",1,0],[0,"NameInFunction",1,0],[0,"NameInLocation",1,0],[0,"NameInProduct",1,0],[0,"SelectedClassification",1,0],[0,"StartIndexInFunction",1,0],[0,"StartIndexInLocation",1,0],[0,"StartIndexInProduct",1,0]],[],[]];
SPLM.AME.NamingRuleBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.NamingRuleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;